<template>
  <v-dialog v-model="dialogState" persistent max-width="800" v-if="transactionData">
    <v-card>
      <v-toolbar color="accent" fixed>
        <v-toolbar-title>
          <v-icon left>mdi-pencil</v-icon>
          {{$vuetify.lang.t('$vuetify.action.edit_transaction')}}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title class="headline"></v-card-title>
      <v-card-text style="min-height:430px;">
        <v-form ref="contactEditForm">
          <v-row align="start">
            <v-col cols="12" md="6">
              <v-text-field
                v-model="transactionData.amount"
                :label="$vuetify.lang.t('$vuetify.tables.amount')"
                type="number"
                :error="validator.amount.error_show"
                :error-messages="validator.amount.error_msg"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="transactionData.payment_type_selected.key == 'barcode'">
              <v-text-field
                v-model="transactionData.barcode_count"
                :label="$vuetify.lang.t('$vuetify.company.barcode_count')"
                type="number"
                :error="validator.barcode_count.error_show"
                :error-messages="validator.barcode_count.error_msg"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="transactionData.payment_type_selected.key == 'membership'">
              <v-text-field
                v-model="transactionData.next_payment_amount"
                :label="$vuetify.lang.t('$vuetify.tables.next_payment_amount')+' *'"
                type="number"
                :error="validator.next_payment_amount.error_show"
                :error-messages="validator.next_payment_amount.error_msg"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" v-if="transactionData.payment_type_selected.key == 'membership'">
              <div class="v-input v-input--hide-details theme--light v-text-field">
                <div class="v-input__control">
                  <div class="v-input__slot" style="width:100" append-icon="mdi-magnify">
                    <div class="v-text-field__slot">
                      <datepicker
                        v-model="transactionData.payed_from"
                        :language="dateLanguage()"
                        :monday-first="true"
                        :placeholder="$vuetify.lang.t('$vuetify.company.payed_from')+' *'"
                        :error="validator.payed_from.error_show"
                        :error-messages="validator.payed_from.error_msg"
                        :highlighted="currentDate"
                      ></datepicker>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="validator.payed_from.error_show" class="error--text caption">
                {{ validator.payed_from.error_msg }}
              </div>
            </v-col>
            <v-col cols="12" md="6" v-if="transactionData.payment_type_selected.key == 'membership'">
              <div class="v-input v-input--hide-details theme--light v-text-field">
                <div class="v-input__control">
                  <div class="v-input__slot" style="width:100" append-icon="mdi-magnify">
                    <div class="v-text-field__slot">
                      <datepicker
                        v-model="transactionData.payed_to"
                        :language="dateLanguage()"
                        :monday-first="true"
                        :placeholder="$vuetify.lang.t('$vuetify.company.payed_to')+' *'"
                        :error="validator.payed_to.error_show"
                        :error-messages="validator.payed_to.error_msg"
                        :highlighted="currentDate"
                      ></datepicker>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="validator.payed_to.error_show" class="error--text caption">
                {{ validator.payed_to.error_msg }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-select
                :label="$vuetify.lang.t('$vuetify.manager.status')+ ' *'"
                :items="statuses"
                v-model="transactionData.status_key"
                item-text="value"
                item-value="key"
                class="mt-5"
              >
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                :label="$vuetify.lang.t('$vuetify.company.comment')"
                v-model="transactionData.note"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn @click="closePopup" :disabled="saving">
          <v-icon class="mr-3">mdi-close</v-icon>
          {{$vuetify.lang.t('$vuetify.action.cancel')}}
        </v-btn>

        <v-btn @click="updateTransaction" :disabled="validator.hasError || saving" :loading="saving">
          <v-icon class="mr-3">mdi-content-save</v-icon>
          {{$vuetify.lang.t('$vuetify.action.update')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "@/services/api";
import TransactionHelper from "@/helpers/transaction";
import Datepicker from "vuejs-datepicker";
import { getDatepickerLocale, getTodayHighlight } from "@/helpers/datepicker";

export default {
  components: {
    Datepicker
  },
  data: function() {
    return {
      currentDate: getTodayHighlight(),
      dialogState: false,
      saving: false,
      transactionData: false,
      transactionDataOriginal: false,
      validator: TransactionHelper.validatorModel(),
      statuses: []
    };
  },
  computed: {
    transactionTypes() {
      return TransactionHelper.itemTypes();
    }
  },
  watch: {
    popupEditTransaction: function(newVal) {
      this.dialogState = newVal;
    },
    transaction: function(newVal) {
      this.statuses = this.$i18n["messages"][this.$i18n.locale]["$vuetify"]["tr_statuses"];
      this.transactionData = Object.assign({}, newVal);
      this.transactionDataOriginal = Object.assign({}, newVal);
      this.validateForm();
    },
    transactionData: {
      deep: true,
      handler() {
        if (this.transactionData) this.validateForm();
      }
    }
  },
  methods: {
    dateLanguage() {
      return getDatepickerLocale(this.$i18n.locale);
    },
    validateForm() {
      this.validator = TransactionHelper.validateForm({
        ...this.transactionData,
        payment_type: this.transactionData.payment_type_selected.key
      });
    },
    closePopup() {
      if (this.saving) return;
      this.dialogState = false;
      this.$emit("closeEditTransactionPopup");
      this.validator = TransactionHelper.validatorModel();
      this.transactionData = Object.assign({}, this.transactionDataOriginal);
    },
    async updateTransaction() {
      this.validateForm();
      if (this.validator.hasError || this.saving) return;

      const d = {
        ...TransactionHelper.paymentPayload({
          ...this.transactionData,
          payment_type: this.transactionData.payment_type_selected.key
        }, this.transactionData.company.id),
        id: this.transactionData.id,
        currency: "gel",
        status: this.transactionData.status_key
      };

      this.saving = true;
      try {
        await Api.payment("update", d);
      } catch (error) {
        this.$toast.error(this.$vuetify.lang.t("$vuetify.errors.system_error"));
        return;
      } finally {
        this.saving = false;
      }
      this.$emit("reload");
      this.$toast.ok(this.$vuetify.lang.t("$vuetify.action.update_success"));
      this.closePopup();
    }
  },
  props: ["transaction", "popupEditTransaction"]
};
</script>
<style scoped>
.vdp-datepicker {
  width: 100%;
}
</style>
